<template>
  <div class="home">
    <ManufactureList v-show="listView" @newManufacture="onClickNewFromList" @editManufacture="onClickEditFromList" :scroll="corY" ref="refreshList"/>
    <ManufactureForm v-show="formView" :manufacture="manufacture" :materialColl="materialColl" @backClicked="onBackChild" @backClickID ="onBackParentID" />
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import ManufactureList from '@/components/manufacture/ManufactureList.vue'
import ManufactureForm from '@/components/manufacture/ManufactureForm.vue'
import { getHeader, manufactureUrl } from '../config'
import { mapState } from 'vuex'

export default {
  name: 'Manufacture',
  components: {
    ManufactureList,
    ManufactureForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      manufacture: {
        id: null,
        manufacture_no: null,
        manufacture_date: null,
        manufacture_start_date: null,
        manufacture_due_date: null,
        manufacture_finish_date: null,
        notes: null,
        person_in_charge: null,
        company_no: null,
        company: null,
        branch_no: null,
        branch: null,
        status: null,
        lock: false,
        inventory_no: null,
        type_id: null,
        total_cost: '0',
        total_expense: '0',
        order_no: null,
        customer_no: null,
        customer: {
          id: null,
          name: null,
          customer_no: null,
          group_id: null,
          email: null,
          phone: null,
          address: null,
          city_id: null,
          state_id: null,
          identity_number: null,
          vat: null,
          birthday: null,
          birthplace: null,
          twitter: null,
          facebook: null,
          instagram: null,
          card_id: null,
          level_id: null,
          company_no: null,
          area_id: null,
          rating_id: null,
          term_due_id: null
        },
        materials: [{
          id: null,
          manufacture_no: null,
          product_no: null,
          product: null,
          qty: null,
          uom_id: null,
          price: '0',
          total_cogs: '0',
          warehouse_no: null,
          receive: null,
          received_by: null,
          receive_date: null,
          company_no: null,
          branch_no: null,
          manufacture_date: null,
          category_id: null,
          type_id: null,
          hand_id: null,
          hand_qty: '0',
          hand_uom_id: null,
          hand_date: null,
          hand_no: null,
          hand_serial_number: null,
          mproduct_no: null,
          limit: null
        }],
        mproducts: [{
          id: null,
          manufacture_no: null,
          product_no: null,
          qty_estimated: null,
          qty_finish: null,
          qty_return: null,
          uom_id: null,
          notes: null,
          price: '0',
          total: '0'
        }],
        expenses: [{
          id: null,
          manufacture_no: null,
          amount: '0',
          notes: null
        }],
        inventories: [{
          id: null,
          inventory_no: null,
          inventory_date: null,
          product_no: null,
          product: null,
          qty_done: '0',
          uom_id: null,
          cost: '0',
          is_cost: false,
          cost_id: null
        }]
      },
      materialColl: [{
        id: null,
        manufacture_no: null,
        product_no: null,
        product: null,
        qty: '0',
        uom_id: null,
        price: '0',
        total_cogs: '0',
        warehouse_no: null,
        receive: null,
        received_by: null,
        receive_date: null,
        company_no: null,
        branch_no: null,
        manufacture_date: null,
        category_id: null,
        type_id: null,
        hand_id: null,
        hand_qty: '0',
        hand_uom_id: null,
        hand_date: null,
        hand_no: null,
        hand_serial_number: null,
        mproduct_no: null,
        limit: null
      }]
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser
    })
  },
  methods: {
    async onClickEditFromList (value) {
      this.$store.commit('SET_PRODUCT_LIST_SELECT', [])
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.manufacture = value
      console.log(manufactureUrl + '/' + value.id)
      await axios.get(manufactureUrl + '/' + value.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.materialColl = response.data.data.materials
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
        })
      // var payload = {
      //   date: this.manufacture.manufacture_date
      // }
      // this.$store.dispatch('getProductListCogs', payload)
      this.$store.dispatch('getProductListSelect')
      var pyd = {
        company: this.authUser.company_no
      }
      await this.$store.dispatch('getInventoryOnHandProductList', pyd)
    },
    getEditManufacture: function (id) {
      axios.get(manufactureUrl + '/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.onClickEditFromList(response.data.data)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    onClickNewFromList: function () {
      this.$store.commit('SET_PRODUCT_LIST_SELECT', [])
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.manufacture = {
        id: null,
        manufacture_no: null,
        manufacture_date: new Date().toISOString(),
        manufacture_start_date: new Date().toISOString(),
        manufacture_due_date: new Date().toISOString(),
        manufacture_finish_date: null,
        notes: null,
        person_in_charge: null,
        company_no: this.authUser.company_no,
        company: null,
        branch_no: this.authUser.branch_no,
        branch: null,
        status: null,
        lock: false,
        inventory_no: null,
        type_id: null,
        total_cost: '0',
        total_expense: '0',
        order_no: null,
        customer_no: null,
        customer: {
          id: null,
          name: null,
          customer_no: null,
          group_id: null,
          email: null,
          phone: null,
          address: null,
          city_id: null,
          state_id: null,
          identity_number: null,
          vat: null,
          birthday: null,
          birthplace: null,
          twitter: null,
          facebook: null,
          instagram: null,
          card_id: null,
          level_id: null,
          company_no: null,
          area_id: null,
          rating_id: null,
          term_due_id: null
        },
        materials: [{
          manufacture_no: null,
          product_no: null,
          product: null,
          qty: null,
          uom_id: null,
          price: '0',
          total_cogs: '0',
          warehouse_no: null,
          receive: null,
          received_by: null,
          receive_date: null,
          company_no: this.authUser.company_no,
          branch_no: this.authUser.branch_no,
          manufacture_date: null,
          category_id: 'order',
          type_id: null,
          hand_id: null,
          hand_qty: '0',
          hand_uom_id: null,
          hand_date: null,
          hand_no: null,
          hand_serial_number: null,
          mproduct_no: null,
          limit: null
        }],
        mproducts: [{
          manufacture_no: null,
          product_no: null,
          qty_estimated: '0',
          qty_finish: '0',
          qty_return: '0',
          uom_id: null,
          notes: null,
          price: '0',
          total: '0'
        }],
        expenses: [{
          manufacture_no: null,
          amount: '0',
          notes: null
        }],
        inventories: [{
          id: null,
          inventory_no: null,
          inventory_date: null,
          product_no: null,
          product: null,
          qty_done: '0',
          uom_id: null,
          cost: '0',
          is_cost: false,
          cost_id: null
        }]
      }
      // var payload = {
      //   date: new Date().toISOString(),
      //   type: [1, 2, 3, 4, 6]
      // }
      // this.$store.dispatch('getProductListCogs', payload)
      this.$store.dispatch('getProductListSelect')
      var pyd = {
        company: this.authUser.company_no
      }
      this.$store.dispatch('getInventoryOnHandProductList', pyd)
    },
    onBackParentID: function (id) {
      axios.get(manufactureUrl + '/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.manufacture = response.data.data
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error!!!',
            error.response.data.message,
            'error'
          )
        })
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.manufacture = {
        id: null,
        manufacture_no: null,
        manufacture_date: null,
        manufacture_start_date: null,
        manufacture_due_date: null,
        manufacture_finish_date: null,
        notes: null,
        person_in_charge: null,
        company_no: null,
        company: null,
        branch_no: null,
        branch: null,
        status: null,
        lock: false,
        inventory_no: null,
        type_id: null,
        total_cost: '0',
        total_expense: '0',
        order_no: null,
        customer_no: null,
        customer: {
          id: null,
          name: null,
          customer_no: null,
          group_id: null,
          email: null,
          phone: null,
          address: null,
          city_id: null,
          state_id: null,
          identity_number: null,
          vat: null,
          birthday: null,
          birthplace: null,
          twitter: null,
          facebook: null,
          instagram: null,
          card_id: null,
          level_id: null,
          company_no: null,
          area_id: null,
          rating_id: null,
          term_due_id: null
        },
        materials: [{
          id: null,
          manufacture_no: null,
          product_no: null,
          product: null,
          qty: null,
          uom_id: null,
          price: '0',
          total_cogs: '0',
          warehouse_no: null,
          receive: null,
          received_by: null,
          receive_date: null,
          company_no: null,
          branch_no: null,
          manufacture_date: null,
          category_id: null,
          type_id: null,
          hand_id: null,
          hand_qty: '0',
          hand_uom_id: null,
          hand_date: null,
          hand_no: null,
          hand_serial_number: null,
          limit: null
        }],
        mproducts: [{
          id: null,
          manufacture_no: null,
          product_no: null,
          qty_estimated: null,
          qty_finish: null,
          qty_return: null,
          uom_id: null,
          notes: null,
          price: '0',
          total: '0'
        }],
        expenses: [{
          id: null,
          manufacture_no: null,
          amount: '0',
          notes: null
        }],
        inventories: [{
          id: null,
          inventory_no: null,
          inventory_date: null,
          product_no: null,
          product: null,
          qty_done: '0',
          uom_id: null,
          cost: '0',
          is_cost: false,
          cost_id: null
        }]
      }
      // await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
      // this.$router.replace({ path: 'purchasing', query: null })
    },
    onClickPaymentFromForm: function (value) {
      this.purchasing = value
      this.paymentView = true
      this.listView = false
      this.formView = false
    },
    cancelPayment: function (id) {
      this.getEditPurchasing(id)
    }
  },
  mounted () {
    this.$store.dispatch('getWarehouseList')
    this.$store.dispatch('getUomList')
    this.$store.dispatch('getEmployeeList')
    this.$store.dispatch('getManufactureTypeList')
    this.$store.dispatch('getManufactureMaterialCategoryList')
    this.$store.dispatch('getManufactureExpenseTypeList')
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getRowTable')
    // get query param from url
    var id = this.$route.query.id
    if (typeof id !== 'undefined') {
      this.getEditManufacture(id)
    }
  }
}
</script>
